import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authGuard, childAuthGuard } from './auth-guard.guard';
import { RegisterUserComponent } from './demo/components/user-management/register-user/register-user.component';
import { SearchCustomerComponent } from './demo/components/customer-management/search-customer/search-customer.component';
import { CustomerDetailComponent } from './demo/components/customer-management/customer-detail/customer-detail.component';
import { PaymentVerificationsListComponent } from './demo/components/payment-verification/payment-verifications-list/payment-verifications-list.component';
import { PaymentVerificationDetailComponent } from './demo/components/payment-verification/payment-verification-detail/payment-verification-detail.component';
import { NewVerificationComponent } from './demo/components/payment-verification/new-verification/new-verification.component';
import { DocumentsListComponent } from './demo/components/documents/documents-list/documents-list.component';
import { CreateDocumentComponent } from './demo/components/documents/create-document/create-document.component';
import { ReportsComponent } from './demo/components/reports/reports.component';
import { VehicleMakesComponent } from './demo/components/vehicle-makes/vehicle-makes.component';
import { AddVehicleMakeComponent } from './demo/components/vehicle-makes/add-vehicle-make/add-vehicle-make.component';
import { VehicleModelsComponent } from './demo/components/vehicle-models/vehicle-models.component';
import { AddVehicleModelComponent } from './demo/components/vehicle-models/add-vehicle-model/add-vehicle-model.component';
import { InsuranceProvidersComponent } from './demo/components/insurance-providers/insurance-providers.component';
import { CreateProviderComponent } from './demo/components/insurance-providers/create-provider/create-provider.component';
import { VehicleDetailComponent } from './demo/components/vehicle-detail/vehicle-detail.component';
import { DriverDetailComponent } from './demo/components/drivers/driver-detail/driver-detail.component';
import { ProviderDetailComponent } from './demo/components/insurance-providers/provider-detail/provider-detail.component';
import { PendingDocumentsCustomersListComponent } from './demo/components/customer-management/pending-documents-customers-list/pending-documents-customers-list.component';
const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    useHash: false,
};

const routes: Routes = [
    {
        path: 'home',
        data: { breadcrumb: '' },
        component: AppLayoutComponent,
        canActivate: [authGuard],
        canActivateChild: [childAuthGuard],
        children: [
            {
                path: '',
                data: { breadcrumb: 'Home / Customers / Search Customer' },
                component: SearchCustomerComponent,
            },
            {
                path: 'users',
                data: { breadcrumb: 'Home / Users' },
                loadChildren: () =>
                    import(
                        './demo/components/user-management/user-management.module'
                    ).then((m) => m.UserManagementModule),
            },
            {
                path: 'users/new',
                data: { breadcrumb: 'Home / Users / Registration' },
                component: RegisterUserComponent,
            },
            {
                path: 'customers/search',
                data: { breadcrumb: 'Home / Customers / Search Customer' },
                component: SearchCustomerComponent,
            },
            {
                path: 'customers/:id',
                data: { breadcrumb: 'Home / Customers / Customer Details' },
                component: CustomerDetailComponent,
            },
            {
                path: 'customers/:id/vehicles/:id',
                data: {breadcrumb: 'Home / Customers / Customer Details / Vehicles / Vehicle Details'},
                component: VehicleDetailComponent
            },
            {
                path: 'customers/:id/drivers/:id',
                data: {breadcrumb: 'Home / Customers / Customer Details / Drivers / Driver Details'},
                component: DriverDetailComponent
            },
            {
                path: 'documents',
                data: { breadcrumb: 'Home / Document Types / List' },
                component: PendingDocumentsCustomersListComponent,
            },
            {
                path: 'vehicle-makes',
                data: { breadcrumb: 'Home / Vehicle Makes / List' },
                component: VehicleMakesComponent,
            },
            {
                path: 'vehicle-makes/new',
                data: { breadcrumb: 'Home / Vehicle Makes / Add' },
                component: AddVehicleMakeComponent,
            },
            {
                path: 'vehicle-models',
                data: { breadcrumb: 'Home / Vehicle Models / List' },
                component: VehicleModelsComponent,
            },
            {
                path: 'vehicle-models/new',
                data: { breadcrumb: 'Home / Vehicle Models / Add' },
                component: AddVehicleModelComponent,
            },
            {
                path: 'documents/new',
                data: { breadcrumb: 'Home / Document Types / New' },
                component: CreateDocumentComponent,
            },
            {
                path: 'payment-verifications',
                data: { breadcrumb: 'Home / Payment Verifications' },
                component: PaymentVerificationsListComponent,
            },
            {
                path: 'payment-verifications/:id',
                data: {
                    breadcrumb:
                        'Home / Payment Verifications / View Payment Verification',
                },
                component: PaymentVerificationDetailComponent,
            },
            {
                path: 'new-payment-verification',
                data: { breadcrumb: 'Home / Payment Verifications / New' },
                component: NewVerificationComponent,
            },
            {
                path: 'reports',
                data: { breadcrumb: 'Home / Reports' },
                component: ReportsComponent,
            },
            {
                path: 'insurance-providers',
                data: { breadcrumb: 'Home / Insurance Providers' },
                component: InsuranceProvidersComponent,
            },
            {
                path: 'insurance-providers/new',
                data: { breadcrumb: 'Home / Insurance Providers / New' },
                component: CreateProviderComponent,
            },
            {
                path: 'insurance-providers/:id',
                data: { breadcrumb: 'Home / Insurance Providers / View' },
                component: ProviderDetailComponent,
            },
            
        ],
    },

    {
        path: '',
        data: { breadcrumb: 'Auth' },
        loadChildren: () =>
            import('./demo/components/auth/auth.module').then(
                (m) => m.AuthModule
            ),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
